var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgProvideADemo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 61,
    viewBox: "0 0 42 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7555 20.4663C37.7555 20.352 37.7555 20.2233 37.7555 20.109C37.7997 18.0669 37.44 16.0361 36.6968 14.1326C35.9537 12.2291 34.8417 10.4901 33.4243 9.01492C32.0068 7.53976 30.3118 6.35732 28.4359 5.53509C26.56 4.71287 24.54 4.26697 22.4912 4.22287C20.4424 4.17876 18.4049 4.53729 16.4952 5.27801C14.5854 6.01874 12.8407 7.12715 11.3607 8.53993C9.88068 9.95272 8.6944 11.6422 7.86948 13.512C7.04456 15.3817 6.59725 17.3951 6.553 19.4372V19.623C6.553 19.766 6.553 19.9232 6.553 20.0804C6.46933 24.2046 8.03281 28.193 10.8994 31.1682C13.7661 34.1434 17.7011 35.8617 21.8388 35.9451C25.9765 36.0285 29.9779 34.4701 32.9628 31.6129C35.9478 28.7556 37.6718 24.8335 37.7555 20.7093V20.4663Z",
    fill: "white",
    stroke: "#3D82F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1255 22.4958C23.3134 22.4958 24.2764 21.5359 24.2764 20.3519C24.2764 19.1679 23.3134 18.208 22.1255 18.208C20.9376 18.208 19.9746 19.1679 19.9746 20.3519C19.9746 21.5359 20.9376 22.4958 22.1255 22.4958Z",
    stroke: "#050505",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0233 11.8623L23.8892 18.98",
    stroke: "#050505",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0972 3.98714V1",
    stroke: "#050505",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3738 1H16.8057",
    stroke: "#050505",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7905 41.6333L36.3218 36.7596C36.8087 36.184 37.4812 35.7951 38.2242 35.6595C38.9671 35.5239 39.7343 35.6501 40.3941 36.0164V36.0164C40.7137 36.2366 40.9866 36.5175 41.1971 36.843C41.4075 37.1685 41.5514 37.5321 41.6207 37.9132C41.6899 38.2942 41.6832 38.6851 41.6007 39.0635C41.5182 39.4419 41.3615 39.8003 41.1398 40.1183L35.1315 49.4228",
    stroke: "#050505",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1601 49.3945C34.3868 50.5842 33.1775 51.4254 31.7904 51.7385H18.1536L14.9272 54.3683",
    stroke: "#050505",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5819 56.0858L4.93164 44.4736L0.409449 48.9811L12.0597 60.5932L16.5819 56.0858Z",
    stroke: "#050505",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3083 45.5215H29.0803C29.8409 45.5215 30.5703 45.2203 31.1082 44.6842C31.646 44.1482 31.9482 43.4211 31.9482 42.663C31.9482 41.7153 31.5706 40.8065 30.8983 40.1364C30.226 39.4663 29.3141 39.0898 28.3633 39.0898H15.2715C13.5077 39.0898 12.8626 39.4757 6.39551 45.9217",
    stroke: "#050505",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvideADemo);
export default __webpack_public_path__ + "static/media/ProvideADemo.e41f3457f7013399e043b27cc41e7b53.svg";
export { ForwardRef as ReactComponent };